import { render } from "./InductionPlan.vue?vue&type=template&id=1f243f48&scoped=true"
import script from "./InductionPlan.vue?vue&type=script&lang=js"
export * from "./InductionPlan.vue?vue&type=script&lang=js"

import "./InductionPlan.vue?vue&type=style&index=0&id=1f243f48&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f243f48"]])

export default __exports__